import { render, staticRenderFns } from "./sysConfigManager.vue?vue&type=template&id=3a94a4f6"
import script from "./sysConfigManager.vue?vue&type=script&lang=js"
export * from "./sysConfigManager.vue?vue&type=script&lang=js"
import style0 from "./sysConfigManager.vue?vue&type=style&index=0&id=3a94a4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports